module.exports = __webpack_public_path__ + "img/2.a32fa5f3.png";